'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeHistogramIcon = function TraceTypeHistogramIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M7 20h8v20H7z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M32 28h8v12h-8zM15 16h9v24h-9z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M24 20h8v20h-8z' })
    );
};

exports.default = TraceTypeHistogramIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeHistogramIcon.js
// module id = 715
// module chunks = 0